import styled from 'styled-components';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers';
import {
  Button,
  FormControl, FormControlLabel, ListSubheader, TextField,
} from '@mui/material';
import { Colors, Styling } from '../../../../constants';
import StyledSelect from '../../../Shared/Select';

export const ModalContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
`;

export const ModalFormContainer = styled.form`
  background-color: white;
  width: 650px;
  border-radius: 4px;
  padding: 24px;
  max-height: calc(100% - 100px);
  overflow-y: auto;
`;

export const ModalFormHeader = styled.h1`
  font-size: 24px;
  font-weight: 700;
  line-height: 32px;
  margin-bottom: 16px;
  display: flex;
  justify-content: space-between;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-size: 16px;
  font-weight: 400;
`;

export const ModalFormLabel = styled.h2`
  cursor: default;
  text-align: left;
  font-weight: 700;
  font-size: 12px;
  line-height: 16px;
`;

export const ModalFormTextField = styled(TextField)`
  margin-top: 5px !important;
`;

export const ModalFormControlLabel = styled(FormControlLabel)`
  margin-left: 0 !important; 
  span {
    font-weight: 700 !important;
    font-size: 12px !important;
    line-height: 16px !important;
  }
`;

export const ModalFormListSubheader = styled(ListSubheader)`
  background-color: white !important;
`;

export const ModalFormControl = styled(FormControl)`
  margin-top: 5px !important;
`;

export const ModalFormGroup = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  & *.placeholder {
    color: #8e8e8e;
    color: darkGray;
    font-weight: 300;
  }
`;

export const ModalFormRow = styled.div`
  margin-bottom: 15px;
  min-height: 25px;
  display: flex;
  justify-content: space-between;
  & > * {
    overflow: auto;
    flex-grow: 1;
    flex-basis: 0;
  }
  & > *.first {
    padding-right: 10px;
  }
  & > *.last {
    padding-left: 10px;
  }
`;

export const ModalFormButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
`;
export const ModalRightFormButtonContainer = styled.div`
  display: flex;
  gap: 5px;
  Button {
  text-transform: none;
  }
`;
export const DateTimeContainer = styled.div`
  margin-top: ${Styling.DEFAULT_SPACING}px;
  display: flex;
  justify-content: space-between;
`;

export const TextContainer = styled.div`
  color: black;
  font-size: 14px;
  opacity: 0.6;
  margin-top: ${Styling.DEFAULT_SPACING}px;
  margin-bottom: ${Styling.DEFAULT_SPACING}px;
  justify-content: center;
`;

export const DatePickerStyled = styled(DatePicker)<DatePickerProps<Date>>({
  'margin-top': '5px !important',
});

export const TimePickerStyled = styled(TextField)({
  'margin-top': '5px !important',
});

export const TeamSelect = styled(StyledSelect)`
  &.AssetFieldSelect__control {
    border-color: ${Colors.BLACK_42};
  }
`;

export const TeamIcon = styled.img`
  display: inline-block;
  margin-right: ${Styling.DEFAULT_SPACING_DOUBLED}px;
  height: 1rem;
  width: 1rem;
  position: relative;
  top: 2px;
`;
